/**
 * Mesmo visual do .form-control (Bootstrap 4) usado pelos demais campos do form,
 * para que os campos react-select fiquem padronizados com os inputs/selects
 * nativos ao redor.
 *
 * Usado por CboAutoComplete e pelos filtros de relatório.
 */
const bootstrapSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "calc(1.5em + 0.75rem + 2px)",
    fontSize: "1rem",
    lineHeight: 1.5,
    borderRadius: "0.25rem",
    borderColor: state.isFocused ? "#80bdff" : "#ced4da",
    backgroundColor: state.isDisabled ? "#e9ecef" : base.backgroundColor,
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,0.25)" : "none",
    "&:hover": {borderColor: state.isFocused ? "#80bdff" : "#ced4da"},
  }),
  valueContainer: (base) => ({...base, padding: "0.375rem 0.75rem"}),
  singleValue: (base) => ({...base, color: "#495057"}),
  placeholder: (base) => ({...base, color: "#6c757d"}),
  menu: (base) => ({...base, fontSize: "1rem", zIndex: 1000}),
};

export default bootstrapSelectStyles;
